import Autenticador from "./Autenticador";

const nombreLlave = "_fechaExpiracionSesion";

function obtenerFechaExpiracion() {
  return parseInt(localStorage.getItem(nombreLlave) || "0", 10);
}

function guardarFechaDeExpiracion() {
  const timeoutEnMinutos = Number(process.env.REACT_APP_TIMEOUT_SESION_MINUTOS);

  localStorage.setItem(
    nombreLlave,
    String(Date.now() + timeoutEnMinutos * 60 * 1000)
  );
}

function cerrarSesion() {
  Autenticador.cerrarSesion();
}

const servicioSesion = {
  obtenerFechaExpiracion,
  guardarFechaDeExpiracion,
  cerrarSesion,
};

export default servicioSesion;
